export default __webpack_public_path__ + "static/media/GR00026-disciple_medal_2.08501e65.svg";